export default {
    isEmpty (object) {
        return object === null || object === undefined ? true : Object.keys(object).length === 0
    }
}